// CaptureUserMenu — sign-out icon button for the capture brand bar.
//
// Single-action surface: a small LogOut icon that calls `logout()`
// directly when tapped. No popover, no avatar, no display-name chrome —
// this surface intentionally avoids the profile look and gives field
// staff exactly one affordance: leave.
//
// Touch target: 44×44 px (AGENTS.md invariant #10).

import { useCallback } from 'react'
import { LogOut } from 'lucide-react'

import { useAuth } from '../../app/auth-provider'

export function CaptureUserMenu() {
  const { logout } = useAuth()

  const handleLogout = useCallback(() => {
    logout()
  }, [logout])

  return (
    <button
      type="button"
      onClick={handleLogout}
      aria-label="Sign out"
      className="flex min-h-11 min-w-11 items-center justify-center rounded-full text-[color:var(--color-cc-cream)]/80 transition hover:bg-[color:var(--color-cc-cream)]/10 hover:text-[color:var(--color-cc-lime)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[color:var(--color-cc-lime)]"
    >
      <LogOut aria-hidden="true" className="h-5 w-5" />
    </button>
  )
}
